export const capKitConfig = {
  roochUrl: 'https://test-seed.rooch.network',
  mcpUrl: 'https://test-cap.nuwa.dev/mcp',
  contractAddress:
    '0xeb1deb6f1190f86cd4e05a82cfa5775a8a5929da49fac3ab8f5bf23e9181e625',
};
